import React from 'react';
import { PaginationProps } from './pagination.types';
import '@/assets/styles/components/pagination.styles.scss';

export const Pagination: React.FC<PaginationProps> = ({ currentPage, totalPages, onPageChange }) => {
	type PageItem = number | '...';

	const getPageNumbers = (): PageItem[] => {
		const pagesSet = new Set([1, totalPages]);
		for (let p = currentPage - 1; p <= currentPage + 1; p++) {
			if (p >= 1 && p <= totalPages) pagesSet.add(p);
		}
		const sorted = [...pagesSet].sort((a, b) => a - b);
		const result: PageItem[] = [];
		for (let i = 0; i < sorted.length; i++) {
			if (i > 0 && sorted[i] - sorted[i - 1] > 1) result.push('...');
			result.push(sorted[i]);
		}
		return result;
	};

	const pageNumbers = getPageNumbers();

	return (
		<div className="pagination">
			<button
				onClick={() => onPageChange(currentPage - 1)}
				disabled={currentPage === 1}
				className="pagination-button">
				<i className="icons-alt-arrow-left" />
			</button>

			{pageNumbers.map((page, idx) => (
				<button
					key={idx}
					onClick={() => (typeof page === 'number' ? onPageChange(page) : undefined)}
					className={`pagination-button ${currentPage === page ? 'active' : ''}`}
					disabled={page === '...'}>
					{page}
				</button>
			))}

			<button
				onClick={() => onPageChange(currentPage + 1)}
				disabled={currentPage === totalPages}
				className="pagination-button">
				<i className="icons-alt-arrow-right" />
			</button>
		</div>
	);
};

export default Pagination;
